import React, { useState, useEffect } from 'react';
import { Modal, Backdrop, Fade, Box, makeStyles, Typography } from '@material-ui/core';
import fontFamily from '../../../assets/css/fonts';
import Button from '../../../components/Buttons/Button';
import Table from '../../../components/ClearingTable/Table';

import { listAccountAccess } from '../../../services/AdministratorService';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& > div:nth-child(1)': {
      flex: 'none',
      marginRight: 7,
      '& > svg': {
        width: 28,
        height: 28,
        '& path': {},
      },
    },
    '& div:nth-child(2)': {
      flex: 1,
    },
    '& div:nth-child(3)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {},
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  fadeModalLg: {
    maxWidth: 1100,
    maxHeight: '90vh',
    width: '100%',
    padding: '0px auto',
    margin: '0px auto',
    backgroundColor: '#ffffff',
    border: 'none',
    borderRadius: 5,
    boxShadow: '0px 0px 10px #333333',
    boxSizing: 'border-box',
    outline: 'none',
    overflowY: 'auto',
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function AccountAccessModal({
  onClose: handleClose,
  open: isOpen,
  value,
}) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  const columns = [
    {
      name: 'usrId',
      label: 'User ID',
      options: {
        display: false,
      },
    },
    {
      name: 'roleId',
      label: 'Role ID',
      options: {
        display: false,
      },
    },
    {
      name: 'accountId',
      label: 'Account ID',
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'rep',
      label: 'Rep',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
  };

  useEffect(
    () => {
      async function init() {
        const data = await listAccountAccess(value);
        setRows(data.accountAccessList);
      }

      if (isOpen) {
        init();
      }
    }, // eslint-disable-next-line
    [isOpen]
  );

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalBackdrop}
      open={isOpen}
      onClose={() => {
        handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.fadeModalLg}>
          <Box component="div">
            <form noValidate autoComplete="off">
              <div className={classes.modalHeader}>
                <Typography
                  id="transition-modal-title"
                  className={classes.textBold}
                  style={{ fontWeight: 'bold', fontSize: '30px' }}
                  gutterBottom
                >
                  ACCOUNT ACCESS LIST
                </Typography>
              </div>
              <div className={classes.modalBody}>
                <Table
                  title={'Account Access List'}
                  data={rows}
                  columns={columns}
                  options={options}
                />
              </div>
              <div className={classes.modalFooter}>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 10, marginTop: 10 }}
                >
                  <Button
                    color="primary"
                    label="Close"
                    onClick={() => {
                      handleClose();
                    }}
                  />
                </div>
              </div>
            </form>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
}
